import React from 'react'
import Style from './Home.module.css'
import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import slider1 from '../img/slider1.jpg'
import slider2 from '../img/slider2.jpg'
import slider3 from '../img/slider3.jpg'
import prouduct1 from '../img/th.jpg'
import prouduct2 from '../img/product-polyester-kasab-zari-thread-3.jpg'
import prouduct3 from '../img/th (1).jpg'
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { EffectCoverflow, Pagination, Navigation } from 'swiper';



const Home = () => {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);

    };

    // card



    return (
        <>
            {/* slider */ }
            <Carousel className={Style.mainslider} activeIndex={ index } onSelect={ handleSelect }>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src={ slider1 }
                        height={ 425 }
                        alt="First slide"
                    />
                    <Carousel.Caption>
                        <p className={ Style.heding }>CELEBRATING 17 YEARS OF SUCCESS</p>
                        <p className={ Style.succses }>KING OF EMBROIDERY COLOUR</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src={ slider2 }
                        height={ 425 }
                        alt="Second slide"
                    />

                    <Carousel.Caption>

                        <p className={ Style.succses }>BHARAT WORK WHICH IS TO SHOWCASE OUR WORK</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src={ slider3 }
                        height={ 425 }
                        alt="Third slide"
                    />

                    <Carousel.Caption>

                        <p className={ Style.succses }>
                            EXPORT QUALITY
                        </p>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>

            {/* section2 */ }
            <center>
                <h2 className={ Style.heding3 }><span className={ Style.heding2 }>Our Products &nbsp; </span> Manufacturer & Exporter Of</h2>
                <br />
                <h5 className='mb-5'>The main products of Khodal Jari company are embroidery all type metallic colour jari.</h5>
            </center>


            {/* section cards */ }
            {/* section3 */ }




            {/* Card */ }

            <div className={ Style.mainrating }>
                <div className={ Style.rathead }>
                    <div className={ Style.rat }>
                        <h4>5.0</h4>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                    </div>
                    <a href="/product" className='text-decoration-none text-light'  >See all reviews</a>

                    <div class={Style.spinner}>
                    
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                </div>
                <div className={ Style.cardsliders }>
                    <div className={ Style.slidermain }>
                        <Swiper
                            effect={ 'coverflow' }
                            grabCursor={ true }
                            centeredSlides={ true }
                            loop={ true }
                            slidesPerView={ 'auto' }
                            coverflowEffect={
                                {
                                    rotate: 0,
                                    stretch: 0,
                                    depth: 150,
                                    modifier: 1.5,
                                }
                            }
                            pagination={ { el: '.swiper_pagination', clickable: true } }
                            navigation={ {
                                nextEl: '.swiper_button_next',
                                prevEl: '.swiper_button_prev',
                                clickable: true,
                            } }
                            modules={ [EffectCoverflow, Pagination, Navigation] }
                            className={ Style.swiper_Container }
                        >
                            <SwiperSlide>
                                <div className={ Style.cardslids }>

                                    <div className={ Style.card }>

                                        <div className={ Style.con1 }>

                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={ Style.cardslids }>
                                    <div className={ Style.card }>


                                        <div className={ Style.con2 }>

                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={ Style.cardslids }>
                                    <div className={ Style.card }>


                                        <div className={ Style.con3 }>

                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={ Style.cardslids }>
                                    <div className={ Style.card }>


                                        <div className={ Style.con4 }>

                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={ Style.cardslids }>
                                    <div className={ Style.card }>


                                        <div className={ Style.con5 }>

                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={ Style.cardslids }>
                                    <div className={ Style.card }>


                                        <div className={ Style.con6 }>

                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={ Style.cardslids }>
                                    <div className={ Style.card }>


                                        <div className={ Style.con7 }>

                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className={ Style.cardslids }>
                                    <div className={ Style.card }>


                                        <div className={ Style.con8 }>

                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                        <div className={ Style.slider_controler }>
                            <div className="swiper_button_prev">
                                <i className="fa-solid fa-less-than"></i>
                            </div>
                            <div className="swiper_button_next">
                                <i className="fa-solid fa-greater-than"></i>
                            </div>
                            <div className={ Style.swiper_pagination }></div>
                        </div>
                    </div>
                </div>
            </div>



            {/* section4 */ }

            <Container className={ "my-5" }>
                <Row>
                    <Col sm={ 12 } lg={ 4 } md={ 6 } className={ Style.logo }></Col>
                    <Col sm={ 12 } lg={ 8 } md={ 6 }>
                        <h1><span className={ Style.welcome }>Welcome to &nbsp;</span>KHODAL JARI</h1>
                        <i> <p>👉 Khodal Jari  was incorporated in 2007 inspired by unique advantages of providing high quality of Metalic Yarn with the unique name of "Khodal jari". We believe in delivering valuable and dependable solutions based on high end technology in the benefit of the textile industry. Khodal jari is one of the very few companies who provide up to 120 different products in Metalic Yarn. The firm is using high quality of machinery in order to maintain the quality of product and because of providing qualitative product its selling is spread over in all over India. The motto of firm is to provide "quality, range and economy".</p></i>
                        <button className={ Style.btn }><Link to={ "/aboutme" }>Read more</Link></button>
                    </Col>
                </Row>

            </Container>

            {/* section mobile photo */ }

            <div className={ Style.mobile }>


                <Container className={ Style.row1 }>
                    <Row >
                        <Col className={ Style.point } sm={ 12 } lg={ 4 } md={ 6 } >
                            <h4>👉reat color fastness</h4>
                            <h4>👉High Quality</h4>
                            <h4>👉High tenacity and tough</h4>
                            <h4>👉Mobile-Ready Experience</h4>
                            <h4>👉Team</h4>
                            <h4>👉Maintenance</h4>

                        </Col>
                        <Col className={ Style.point } sm={ 12 } lg={ 4 } md={ 6 } >
                            <h4>👉Accurate and splendid colors</h4>
                            <h4>👉Competitive Price</h4>
                            <h4>👉Variety</h4>
                            <h4>👉Raw Material</h4>
                            <h4>👉Quality Assessment</h4>
                            <h4>👉The Latest Collection</h4>

                        </Col>

                        <Col className={ Style.point } sm={ 12 } lg={ 4 } md={ 12 } mt-5>
                            <div className={ Style.contact }>
                                <center>
                                    <br />
                                    <h2 className={ Style.name }>Khodal Jari Compny</h2><br /><br />
                                    <h6>The main products of Khodal Jari company are embroidery and all type of
                                        metallic colour Yarn and Cording thread.
                                    </h6><br />
                                    <button className={ Style.btn }>
                                        <Link to={ "/product" }>Get a free Quote</Link>
                                    </button><br /><br />
                                    <h4>or give us call +91 9313696550</h4>

                                </center>
                            </div>
                        </Col>

                    </Row>

                </Container>

            </div>

            {/* section5 progress */ }

            {/* <div className={ Style.perelex }></div> */ }

            {/* section6 slider */ }

            <Carousel className={Style.mainslider} activeIndex={ index } onSelect={ handleSelect }>

                <Carousel.Item>
                    <div className={ Style.slider1 }>
                        <img

                            src="https://aksharlon.com/images/1.jpg"
                            alt="First slide"
                        />
                    </div>
                    <Carousel.Caption className={ Style.rw }>
                        <h1>We believe in the need for letter based on the need for weight and quality.</h1>
                        <h3>⭐⭐⭐⭐⭐</h3>
                        <h3>Vraj fashion</h3>
                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item>
                    <div className={ Style.slider1 }>
                        <img

                            src="https://aksharlon.com/images/1.jpg"
                            alt="First slide"
                        />
                    </div>

                    <Carousel.Caption className={ Style.rw }>
                        <h1>Using the Khodal Jari for the last 7 years, we have achieved satisfactory results.</h1>
                        <h3>⭐⭐⭐⭐⭐</h3>
                        <h3>Madhav Fashion</h3>

                    </Carousel.Caption>
                </Carousel.Item>

                <Carousel.Item>
                    <div className={ Style.slider1 }>
                        <img

                            src="https://aksharlon.com/images/1.jpg"
                            alt="First slide"
                        />
                    </div>

                    <Carousel.Caption className={ Style.rew }>
                        <h1>Your personal commitment to excellence has inspired others to push past mediocrity. They are changed because of you.</h1>
                        <h3>⭐⭐⭐⭐⭐</h3>
                        <h3>Vandana Fashion</h3>


                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>

            {/* section portfolio */ }

            <br />
            <center>
                <h2 className={ Style.portfolio }>RECENT PORTFOLIO ITEMS</h2>
            </center><br />
            <Container className='mb-5'>
                <Row>
                    <Col sm={ 12 } lg={ 4 } md={ 12 } className={ Style.products }>
                        <img src={ prouduct1 } alt="not-img" />
                    </Col>
                    <Col sm={ 12 } lg={ 4 } md={ 12 } className={ Style.products }>
                        <img src={ prouduct2 } alt="not-img" />

                    </Col>
                    <Col sm={ 12 } lg={ 4 } md={ 12 } className={ Style.products }>
                        <img src={ prouduct3 } alt="not-img" />
                    </Col>
                </Row>

            </Container>








        </>
    )
}

export default Home
